import { ToolCall } from "@cohesive/api-client";
import { Markdown } from "@cohesive/ui-components";
import React from "react";
import { titleCase } from "title-case";

export function ToolCallArguments({
  args,
  toolCall,
}: {
  args: Record<string, any>;
  toolCall: ToolCall;
}) {
  return (
    <div className="grid grid-cols-[auto_1fr] gap-2 text-base">
      {Object.entries<string>(args).map(([key, value], i) => {
        const formattedKey = titleCase(key.replace(/_/g, " "));

        if (!value) {
          return null;
        }

        if (Array.isArray(value) && value.length === 0) {
          return null;
        }

        if (key === "action_description") {
          return null;
        }

        if (Array.isArray(value)) {
          return (
            <React.Fragment key={`${key}:${i}`}>
              <span className="font-bold">{formattedKey}:</span>
              <div>
                {value.map((v, i) => (
                  <div key={i}>{v}</div>
                ))}
              </div>
            </React.Fragment>
          );
        }

        if (typeof value === "object" && value !== null) {
          return (
            <React.Fragment key={`${key}:${i}`}>
              <span className="font-bold my-2">{formattedKey}:</span>
              <ToolCallArguments
                key={`${key}:${i}`}
                args={value}
                toolCall={toolCall}
              />
            </React.Fragment>
          );
        }

        return (
          <React.Fragment key={`${key}:${i}`}>
            <span className="font-bold my-2">{formattedKey}:</span>
            <span>
              <Markdown>{value}</Markdown>
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
}
